import React from "react";

/** ASSETS */
import {ReactComponent as QRCodeDownloadApp} from "assets/svg/onlink_to_hm9hh8.svg"

export const CQRCodes: any = {
  download: <QRCodeDownloadApp />
}
